<template>
    <div>
        <div class="flex justify-between items-center mb-6">
            <div class="flex cursor-pointer text-green-600 hover:text-green-700" @click="goBack">
                <i class='bx bx-left-arrow-alt bx-sm my-auto'></i>
                <p class="text-xl font-semibold">Thêm mới giảng viên</p>
            </div>
            <button @click="saveAction" class="admin-save-btn">
                <i class='bx bx-save text-white my-auto' ></i><p>Lưu</p>
            </button>
        </div>
        <div class="entry-detail grid grid-cols-1 lg:grid-cols-2 gap-4">
            <entryName v-model="entry" @update="(e) => (entry = e)" />
            <entryEmail v-model="entry" @update="(e) => (entry = e)" />
            <entryPhone v-model="entry" @update="(e) => (entry = e)" />
            <entryUniversity v-model="entry" @update="(e) => (entry = e)" />
            <entryDescription v-model="entry" @update="(e) => (entry = e)" />
            <entryImage v-model="entry" @update="(e) => (entry = e)" />
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import entryName from './partials/entry-name.vue';
import entryEmail from './partials/entry-email.vue';
import entryImage from './partials/entry-image.vue';
import entryPhone from './partials/entry-phone.vue';
import entryUniversity from './partials/entry-university.vue';
import entryDescription from './partials/entry-description.vue';
export default {
    name: 'create',
    components: {
        entryPhone, entryName, entryEmail, entryImage, entryDescription, entryUniversity
    },
    data() {
        return {
            entry: {
                name: '',
                phone: '',
                email: '',
                image: '',
                university: '',
                description: '',
            }
        }
    },
    methods: {
        ...mapActions('staff', ['CreateStaff']),
        saveAction() {
            let validate = {
                name: 'Tên giảng viên',
                email: 'Email',
                phone: 'Số điện thoại',
                university: 'Trường đại học',
                description: 'Mô tả',
                image: 'Hình ảnh',
            };
            if (!this.$validator(this.entry, validate)) return
            this.$swal.fire({
            title: 'Thêm mới giảng viên?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Thêm!',
            cancelButtonText: 'Hủy'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await this.CreateStaff(this.entry);
                    this.goBack()
                }
            })
        },
        goBack() {
            this.$router.push({
				name: "admin." + this.$route.name.split(".")[1],
			});
        }
    }
}
</script>
<style>
.entry-detail .form-group {
    margin-bottom: 0;
}
</style>